// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/checklists-airmanship.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/checklists-airmanship/checklists-airmanship.js';

mount([g0]);
